import React from 'react';
import { useSelector } from 'react-redux';
import Filter from '../../Filter.jsx';
import { getPinnedSavedCustomFilters } from 'selectors';

const PinnedSavedCustomFilters = ({
  currentFilter,
  hasNotification,
  conversationLengths,
  onSavedCustomFilterTabSelect,
  onRemoveCustomFilter,
}) => {
  const pinnedSavedCustomFilters = useSelector(
    getPinnedSavedCustomFilters
  );
  return (
    <>
      {pinnedSavedCustomFilters.map(({ id, name }, index) => (
        <Filter
          key={index}
          className='PinnedSavedCustomFilter'
          filter={name}
          isActive={currentFilter === id}
          hasUnreads={hasNotification[id]}
          length={conversationLengths[id]}
          onFilterSelected={() => onSavedCustomFilterTabSelect(id)}
          onFilterClear={
            currentFilter === id
              ? () => {
                  onRemoveCustomFilter(id);
                }
              : null
          }
        />
      ))}
    </>
  );
};

export default PinnedSavedCustomFilters;
